var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcSmdPadGeneratorInteractionModel = require('../ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var ChipPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(ChipPadGeneratorInteractionModel, IpcSmdPadGeneratorInteractionModel);
ChipPadGeneratorInteractionModel.$class = 'ChipPadGeneratorInteractionModel';

module.exports = ChipPadGeneratorInteractionModel;

ChipPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;
    IpcSmdPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.componentFamily = this.shadow("componentFamily",
        function() {
            return self.data.componentFamily();
        },
        function(value) {
            return self.data.componentFamily(value);
        },
        [self.data.componentFamily]
    );

    this.oddPadWidthMin = this.shadow("oddPadWidthMin",
        function() {
            return self.data.oddPadWidthMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadWidthMin(parseFloat(value) * self.getUnitFactor());
        },
        [self.data.oddPadWidthMin, this.userSettingsModel.distanceUnit]
    );

    this.oddPadWidthMax = this.shadow("oddPadWidthMax",
        function() {
            return self.data.oddPadWidthMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadWidthMax(parseFloat(value) * self.getUnitFactor());
        },
        [self.data.oddPadWidthMax, this.userSettingsModel.distanceUnit]
    );
};

ChipPadGeneratorInteractionModel.prototype.getInspectorElementForComponentFamily = function() {
    var componentFamilyList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.chipComponentFamily) {
        var c = cio_datamodel.IpcDataModel.ComponentAttribute.chipComponentFamily[t];
        componentFamilyList.push([this.LCLZ(t, c), c]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('componentFamily', 'Component Family'), this.componentFamily, componentFamilyList)];
};

ChipPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    var normalTerminalLength = PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('terminalLength', 'Terminal Length'), false, this.padWidthMin, false, this.padWidthMax, this.userSettingsModel.distanceUnit);
    var oddTerminalLength = PackageGeneratorInspectorConfig.getMinMaxRow('L1', this.LCLZ('oddTerminalLength', 'Odd Terminal Length'), false, this.oddPadWidthMin, false, this.oddPadWidthMax, this.userSettingsModel.distanceUnit);

    return [normalTerminalLength, oddTerminalLength];
};

ChipPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

ChipPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

ChipPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintChip));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForOddPadLengthInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForComponentFamily());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};